import React from "react";
import dayjs from "dayjs";

import ECD from "../components/ECD";

const Scheduled = (props) => {
    const dropDate = new Date(props.VehEntry.DropDate).toLocaleDateString();

    return (
        <div>
            <div class="container">
                <div class="row">
                    <div className="row customer-support text-center" style={{ marginTop: 10 }}>
                        <h4 style={{ color: "black" }}>{props.VehEntry.Veh_Year} {props.VehEntry.Veh_Make} {props.VehEntry.Veh_Model}</h4>
                        <p style={{ marginTop: 10, color: "black" }}>Scheduled</p>
                        <p><b>{props.Veh_Year}</b></p>
                    </div>
                </div>
            </div>
            <div className="sec-title text-left" style={{ marginTop: 10 }}>
                <h4 style={{ color: "black" }}>What does this mean?</h4>
                <span className="decor" />
                {dropDate ?
                    <p style={{ color: "black" }}>Your vehicle repair is scheduled for <strong>{dayjs(props.VehEntry.DropDate.toDate()).format('MM/DD/YYYY')}</strong>. If you have already dropped off your vehicle, we will update the status as soon as we have finished the check-in process. This may take several hours depending on the claim.</p> :
                    <p style={{ color: "black" }}>Your vehicle repair is scheduled for repair. If you have already dropped off your vehicle, we will update the status as soon as we have finished the check-in process. This may take several hours depending on the claim.</p>
                }
            </div>
            <div className="sec-title text-left">
                <h4 style={{ color: "black" }}>What is next?</h4>
                <span className="decor" />
                <p style={{ color: "black" }}>Once we finish up the pre-repair paperwork and diagnostic scans (if applicable) the vehicle will move to the teardown/blueprint phase where we will remove the necessary parts to complete the repair and prepare for body work.</p>
            </div>
            <div className="sec-title text-left">
                <h4 style={{ color: "black" }}>Estimated Completion Date</h4>
                <span className="decor" />
                <ECD ecd={props.VehEntry.EstimatedCompletionDate} />
            </div>
        </div>
    )
}

export default Scheduled